var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftSubArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01435 0.412893L0.407354 4.01989C-0.135785 4.56303 -0.135785 5.44041 0.407354 5.98354L4.01435 9.59054C4.89173 10.4679 6.3958 9.84122 6.3958 8.60175V1.38776C6.3958 0.148287 4.89173 -0.464485 4.01435 0.412893Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSubArrow);
export default __webpack_public_path__ + "static/media/leftSubArrow.f4e1aaa7024badb8c970f9fa565b0169.svg";
export { ForwardRef as ReactComponent };